import _ from 'lodash';
import moment from 'moment';

import { firebase } from '@/plugins/firebase';

const functions = firebase.app().functions('asia-northeast1');

export async function getNews(limit) {
  const oncall = functions.httpsCallable("getNews");
  const response = await oncall();

  let newsArray = response.data
    .map(item => {
      if (item.length != 6) return;

      return {
        id: item[0] != '' ? item[0] : '000000000000000000000',
        releaseDate: item[1] != '' ? item[1] : '0000-00-00',
        title: item[2] != '' ? item[2] : 'タイトルなし',
        article: item[3] != '' ? item[3] : '内容なし',
        url: item[4] != '' ? item[4] : '#',
        createAt: item[5] != '' ? item[5] : '0000-00-00'
      };
    })
    .filter(news => {
      return (
        Boolean(news) &&
        moment(news.releaseDate).isSameOrBefore(moment(), 'day')
      );
    });

  newsArray = _.orderBy(newsArray, 'releaseDate', 'desc');

  return newsArray.slice(0, limit);
}

export async function getFaqs() {
  const oncall = functions.httpsCallable("getFaqs");
  const response = await oncall();

  return response.data
    .map(item => {
    if (item.length != 4) return;
    if (!item[1] || !item[2] || !item[3]) return;

    return {
      id: item[0],
      title: item[1],
      answer: item[2],
      updatedDate: item[3]
    };
  });
}
